import { Component, Inject, ChangeDetectorRef } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { SharedService } from 'src/app/shared/services/shared.service'
import { OrderStatus } from '../../models/order.enum'

@Component({
	selector: 'app-update-order-status-popup',
	templateUrl: './update-order-status-popup.component.html',
	styleUrl: './update-order-status-popup.component.scss',
})
export class UpdateOrderStatusPopupComponent {
	state!: any
	statusList: any[] = []

	label: string = ''
	showInput: boolean = false

	formGroup: FormGroup = new FormGroup({})

	orderDeliverStatus = this.SharedService.returnEnumArray(OrderStatus)
	currentStatus: any
	constructor(
		public dialog: MatDialogRef<UpdateOrderStatusPopupComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public translate: TranslateService,
		private SharedService: SharedService,
		private cdr: ChangeDetectorRef
	) {
		this.formGroup.valueChanges.subscribe((res) => this.formGroup.controls)
		this.statusList = this.orderDeliverStatus.filter(
			(item) => data?.enums?.includes(item?.value) && item?.value !== 7
		)
		this.initForm()
	}
	initForm() {
		this.currentStatus = this.orderDeliverStatus.filter(
			(ele: any) => ele?.value == this.data?.current
		)
		console.log(this.currentStatus)

		this.formGroup = new FormGroup({
			newStatus: new FormControl('', Validators.required),
			awb: new FormControl(null),
			date: new FormControl(null),
			reason: new FormControl(null),
		})
	}
	ngAfterViewChecked() {
		//your code to update the model
		this.cdr.detectChanges()
	}
	changeOrderStatus() {
		if (
			this.data?.current == 1 &&
			this.getController('newStatus')?.value?.value == 2
		) {
			this.getController('awb').clearValidators()
			this.getController('date').clearValidators()
			this.getController('reason').setValidators([Validators.required])
			this.formGroup.updateValueAndValidity()

			this.showInput = true
			this.label = 'REASON'
		} else if (
			this.data?.current == 3 &&
			this.getController('newStatus')?.value?.value == 4
		) {
			this.showInput = true
			this.label = 'AWB'
			this.getController('reason').clearValidators()
			this.getController('date').clearValidators()
			this.getController('awb').setValidators([Validators.required])
			this.formGroup.updateValueAndValidity()
		} else if (
			this.data?.current == 5 &&
			this.getController('newStatus')?.value?.value == 6
		) {
			this.getController('reason').clearValidators()
			this.getController('awb').clearValidators()
			this.getController('date').setValidators([Validators.required])

			this.formGroup.updateValueAndValidity()

			this.showInput = true
			this.label = 'date'
		} else {
			this.getController('date')
				? this.getController('date').setValue(null)
				: null
			this.getController('awb')
				? this.getController('awb').setValue(null)
				: null
			this.getController('reason')
				? this.getController('reason').setValue(null)
				: null
			this.showInput = false
			this.getController('reason').clearValidators()
			this.getController('awb').clearValidators()
			this.getController('date').clearValidators()
			this.getController('reason').setErrors(null)
			this.getController('awb').setErrors(null)
			this.getController('date').setErrors(null)
			this.formGroup.updateValueAndValidity()
			this.cdr.detectChanges()
		}
	}

	closeDialog() {
		this.dialog.close()
	}

	confirm() {
		this.dialog.close(this.formGroup.getRawValue())
	}
	getController(controlName: string) {
		return this.formGroup.controls[controlName]
	}
}
